import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { Map, MapMarker, MarkerClusterer, ZoomControl } from "react-kakao-maps-sdk";
import { storePlaceList } from "store/placeValue";
import PlaceMapModal from "./PlaceMapModal";
import { storeSearchStart } from "store/searchValue";

export default function PlaceMapMap() {
  const placeList = useAtomValue(storePlaceList)
  const searchStart = useAtomValue(storeSearchStart)

  const [info, setInfo] = useState<any>()
  const [centerPosition, setCenterPosition] = useState<any>({
    center: {
      lat: 37.5308561175718, // 위도
      lng: 126.990949104616 // 경도
    }
  })
  const [modalOpen, setModalOpen] = useState<boolean>(false)

  useEffect(() => {
    if (navigator.geolocation) {
      // GeoLocation을 이용해서 접속 위치를 얻어옵니다
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCenterPosition((prev: any) => ({
            center: {
              lat: position.coords.latitude, // 위도
              lng: position.coords.longitude, // 경도
            }
          }))
        },
        (err) => {
          setCenterPosition((prev: any) => ({
            center: {
              lat: 37.5308561175718, // 위도
              lng: 126.990949104616 // 경도
            }
          }))
        }
      )
    } else {
      // HTML5의 GeoLocation을 사용할 수 없을때 마커 표시 위치와 인포윈도우 내용을 설정합니다
      setCenterPosition((prev: any) => ({
        center: {
          lat: 37.5308561175718, // 위도
          lng: 126.990949104616 // 경도
        }
      }))
    }
  }, [searchStart, placeList])

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  return (
      <>
        <Map
            // center={{ lat: 37.5308561175718, lng: 126.990949104616 }}
            center={centerPosition?.center}
            style={{ width: "100vw", height: window.innerHeight - 120 + 'px' }}
            level={12}
        >
          <MarkerClusterer
            averageCenter={true} // 클러스터에 포함된 마커들의 평균 위치를 클러스터 마커 위치로 설정
            minLevel={11} // 클러스터 할 최소 지도 레벨
          >
            {placeList?.map((marker: any) => (
                <MapMarker
                    key={`marker-${marker.title}-${marker.lat},${marker.lng}`}
                    position={{
                      lat: marker.lat,
                      lng: marker.lng
                    }}
                    onClick={() => {
                      setInfo(marker)
                      handleOpen()
                    }}
                >
                </MapMarker>
            ))}
          </MarkerClusterer>
          <ZoomControl position={"BOTTOMRIGHT"} />
        </Map>

        <PlaceMapModal modalOpen={modalOpen} handleClose={handleClose} info={info} />
      </>
    )
}
